var map = {
	"./symbol_0.png": 94191,
	"./symbol_1.png": 55174,
	"./symbol_2.png": 96413,
	"./symbol_3.png": 75284,
	"./symbol_4.png": 21195,
	"./symbol_5.png": 66,
	"./symbol_6.png": 48249,
	"./symbol_7.png": 51344,
	"./symbol_8.png": 18231
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30378;